import script from "./AssetsMixin.vue?vue&type=script&lang=ts"
export * from "./AssetsMixin.vue?vue&type=script&lang=ts"

export default script